import SvgSearch from '@img/icons/search.svg';
import * as React from 'react';
import S from './Search.styles';
const Search = (props) => {
    const [searchTerm, setSearchTerm] = React.useState(props.initialValue ?? '');
    return (React.createElement(S.Container, { onSubmit: (e) => {
            e.preventDefault();
            props.onSubmit(searchTerm);
        } },
        React.createElement(S.InputWrapper, null,
            React.createElement(S.Input, { id: "searchText", autoComplete: "off", name: "searchText", placeholder: props.placeholder, type: "search", value: searchTerm, onChange: (event) => {
                    setSearchTerm(event.target.value);
                } }),
            React.createElement(S.Button, null,
                React.createElement(S.ButtonIcon, { as: SvgSearch }),
                React.createElement(S.ButtonLabel, null, "Search")))));
};
export default Search;
